import React, { useState, useRef } from 'react';
    import { cn } from '@/lib/utils';
    import { Link } from 'react-router-dom';
    import { useDebug } from '@/contexts/DebugContext';
    import toast from 'react-hot-toast';

    export function Logo({ className, showText = true }) {
      const { toggleDebug, debugEnabled } = useDebug();
      const [clickCount, setClickCount] = useState(0);
      const lastClickTime = useRef(0);

      // Hidden Mobile Trigger: 5 rapid taps on logo enables debug mode
      const handleSecretTrigger = (e) => {
        const now = Date.now();
        if (now - lastClickTime.current > 500) {
          setClickCount(1);
        } else {
          const newCount = clickCount + 1;
          setClickCount(newCount);
          
          if (newCount === 5) {
            const newState = !debugEnabled;
            toggleDebug(newState);
            toast.success(`Debug Console ${newState ? 'Enabled' : 'Disabled'}`, {
              icon: '🛠️',
              style: { borderRadius: '10px', background: '#333', color: '#fff' }
            });
            setClickCount(0);
          }
        }
        lastClickTime.current = now;
      };

      return (
        <div className={cn("flex items-center gap-3", className)}>
          <div 
            onClick={handleSecretTrigger}
            className="cursor-pointer active:scale-95 transition-transform"
          >
            <img 
              src="https://res.cloudinary.com/dfg8nrgvf/image/upload/q_auto/f_auto/v1779211733/Remove_Background_e9npzp.png" 
              alt="Roaming Logos" 
              className="w-12 h-12 object-contain"
              onError={(e) => {
                e.target.onerror = null;
                e.target.src = "/logo.svg";
              }}
            />
          </div>
          {showText && (
            <Link to="/" className="font-black text-xl tracking-tighter text-slate-900 dark:text-white">
              ROAMING<span className="text-primary-500">LOGOS</span>
            </Link>
          )}
        </div>
      );
    }